export default (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
  },
  toggleSwitch: {
    position: 'relative',
    display: 'flex',
    width: 85,
    height: 40,
    borderRadius: 35,
    backgroundColor: '#b0b1b1',
    '&.newDesign': {
      width: 42,
      height: 24,
      marginBottom: 8,
      borderRadius: 20,
    },
  },
  active: {
    backgroundColor: theme.palette.primary.main,
  },
  switch: {
    position: 'absolute',
    opacity: 0,
    width: 85,
    height: '100%',
    '&.newDesign': {
      width: 42
    }
  },
  slider: {
    position: 'relative',
    display: 'block',
    height: 30,
    width: 30,
    borderRadius: '50%',
    backgroundColor: 'white',
    transition: '.4s',
    '&.newDesign': {
      height: 18,
      width: 18,
    }
  },
  sliderNull: {
    margin: 'auto',
  },
  sliderOn: {
    margin: 'auto 5px auto auto',
    '&::before': {
      content: "'ja'",
      position: 'absolute',
      left: -35,
      top: 5,
      textTransform: 'uppercase',
      width: '100%',
      height: '100%',
      fontSize: 16,
      fontFamily: 'Roboto-Bold',
      color: 'white',
    },

    '&.newDesign': {
      margin: 'auto 2px auto auto',
      '&::before': {
        left: 28,
        top: -1,
        textTransform: 'capitalize',
        color: 'initial',
        fontFamily: 'Roboto-Regular',
      }
    }
  },
  sliderOff: {
    margin: 'auto auto auto 5px',
    '&::before': {
      content: "'nein'",
      position: 'absolute',
      left: 35,
      top: 5,
      textTransform: 'uppercase',
      width: '100%',
      height: '100%',
      fontSize: 16,
      fontFamily: 'Roboto-Bold',
      color: 'white'
    },

    '&.newDesign': {
      margin: 'auto auto auto 2px',
      '&::before': {
        left: 48,
        top: -1,
        textTransform: 'capitalize',
        color: 'initial',
        fontFamily: 'Roboto-Regular',
      }
    },
  },
  labelRoot: {
    color: '#202A38',
    transform: 'none',
    position: 'relative',
    fontSize: 16,
    marginBottom: 14,
    fontFamily: 'Roboto-Bold',
    '&.newDesign': {
      fontSize: 12,
      fontFamily: 'Roboto-Bold',
    }
  },
  labelAsterisk: {
    color: theme.palette.primary.main
  },
  error: {
    marginTop: 14,
  }
})